import types from '../types/orchestrator'
// import startActions from '../actions/start'

export default class remove {

  static setOpen(isOpen, isActive) {
    return {
      type: types.SET_OPEN,
      payload: {
        isOpen,
        isActive: typeof isActive === 'undefined' ? isOpen : isActive,
      },
    }
  }

  static start(item) {
    return function(dispatch) {

      dispatch({
        type: types.START,
        payload: {
          item,
        },
      })

      // dispatch(startActions.createRent())
    }
  }

  static setFlowStep(flowStep) {
    return {
      type: types.SET_FLOW_STEP,
      payload: {
        flowStep,
      },
    }
  }

  static setFlowReset(flowReset) {
    return {
      type: types.SET_FLOW_RESET,
      payload: {
        flowReset,
      },
    }
  }

  static setFlowLoading(flowLoading) {
    return {
      type: types.SET_FLOW_LOADING,
      payload: {
        flowLoading,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/remove/actions/orchestrator.js